// ELECTION SECURITY page component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE 
//import $ from 'jquery'
//import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
//import TableOfContents from '../../components/TableOfContents'
import FullWidthImage from '../../components/FullWidthImage'
//import ContentBlock from  '../../components/ContentBlock'
import TextBlock from '../../components/textblock'
//import Header from '../../components/Header'
//import ContentList from '../../components/ContentList'
//import ContentGridNew from '../../components/ContentGridNew'
//import BodySection from '../../components/BodySection'
//import ContentsTable from '../../components/ContentsTable'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const electionSecurityPage = ({data}) => {
    
    const electionSecurity = data.election_security.edges
    
    return (   
        
        <div>
            
            
            <Helmet>
                   <title>NJCCIC Election Security</title>
                    <meta name="description" content="NJCCIC information on New Jersey election Security"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>
        
            {electionSecurity.map(({ node: {page_title, image, introductory_text} }) => (
        
                <div class="container-fluid">
    
                    <PageHeader divClass="background" elementClass="pageHeader centerText" title={page_title}/>  
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>
                                        
                    <FullWidthImage alt="Election Security Voter" src={image}/>
                    
                </div> 
        
            ))}
        
            <Footer/>
                
            
        </div> 

    )   
    
}
//*******************************************************************
//******************************************************************* 
export const query = graphql`
    query {
        election_security: allButterPage(filter: {slug: { eq: "election-security" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    introductory_text
                    image
                }
            }
        }
       
    }
`
export default electionSecurityPage
//******************************************************************* 